module.exports = __webpack_public_path__ + "img/logo.7fa7749c.png";